/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { Box, TextHeading, TextBody, Link } from '@ally/metronome-ui';
import { space } from 'styled-system';
import { isAfterDeliverOnDate } from '../utils';
import { WireRequestedDescription, WireReviewingDescription, WireNeedsAttentionDescription, WireProcessingDescription, WireCanceledDescription, WireSentDescription, WireContactUsDescription, } from './StatusModalWireData';
import { getCheckShippedDescription } from './StatusModalCheckData';
import { AchProcessingDescription, AchDeliveredDescription, } from './StatusModalAchData';
var StyledTextHeading = styled(TextHeading)(space);
function getAchStepInProcess(event) {
    return (event.activityName === 'ACHTransfer' &&
        event.statuses[0].status === 'InProcess');
}
function getHeading(event) {
    var activityName = event.activityName, eventModelData = event.eventModelData, statuses = event.statuses;
    var deliverOnDate = eventModelData.deliverOnDate;
    var currentStatus = statuses[0].status;
    var isAch = activityName === 'ACHTransfer';
    var showAchDelivered = getAchStepInProcess(event) && isAfterDeliverOnDate(deliverOnDate);
    switch (currentStatus) {
        case 'Confirmed':
            return 'Ordered';
        case 'InProcess':
            return isAch && showAchDelivered
                ? 'Delivered'
                : isAch
                    ? 'Processing'
                    : 'Ordered';
        case 'VerificationRequired':
            return 'Needs Attention';
        case 'Completed':
        case 'Posted':
            return 'Delivered';
        default:
            return currentStatus;
    }
}
function getCheckDescription(statuses) {
    switch (statuses[0].status) {
        case 'Shipped':
            return getCheckShippedDescription(statuses);
        default:
            return (React.createElement(TextBody, { tag: "p", size: "sm" }, "We're printing your checks and preparing them for shipping."));
    }
}
function getWireDescription(statuses) {
    switch (statuses[0].status) {
        case 'Reviewing':
            return React.createElement(WireReviewingDescription, null);
        case 'VerificationRequired':
            return React.createElement(WireNeedsAttentionDescription, null);
        case 'Processing':
            return React.createElement(WireProcessingDescription, { statuses: statuses });
        case 'Canceled':
            return React.createElement(WireCanceledDescription, { statuses: statuses });
        case 'Sent':
            return React.createElement(WireSentDescription, null);
        default:
            return React.createElement(WireRequestedDescription, null);
    }
}
function getAchDescription(currentStatus) {
    switch (currentStatus) {
        case 'Completed':
        case 'Posted':
            return React.createElement(AchDeliveredDescription, null);
        default:
            return React.createElement(AchProcessingDescription, null);
    }
}
function getDescriptionType(event) {
    var activityName = event.activityName, eventModelData = event.eventModelData, statuses = event.statuses;
    var deliverOnDate = eventModelData.deliverOnDate;
    var currentStatus = statuses[0].status;
    var showAchDelivered = getAchStepInProcess(event) && isAfterDeliverOnDate(deliverOnDate);
    switch (activityName) {
        case 'CheckOrder':
            return getCheckDescription(statuses);
        case 'ACHTransfer':
        case 'InternalTransfers':
            return showAchDelivered
                ? getAchDescription('Completed')
                : getAchDescription(currentStatus);
        default:
            return getWireDescription(statuses);
    }
}
var StatusModalDescription = function (_a) {
    var event = _a.event, isStandaloneModal = _a.isStandaloneModal, isWiresMigrationEnabled = _a.isWiresMigrationEnabled;
    var contactUsFlag = event.eventModelData.contactUsFlag;
    var showContactUs = isWiresMigrationEnabled && contactUsFlag;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { borderBottom: "solid 1px", borderColor: "slate-3" },
            React.createElement(StyledTextHeading, { tag: "h2", size: "sm", mb: "xs", mt: "md" }, showContactUs ? 'Action required' : getHeading(event)),
            React.createElement(Box, { mb: "md" }, showContactUs ? (React.createElement(WireContactUsDescription, null)) : (getDescriptionType(event))),
            isStandaloneModal && (React.createElement(Box, { mb: "md" },
                React.createElement(Link, { text: "View all items", to: "/status-tracker" }))))));
};
export default StatusModalDescription;
//# sourceMappingURL=StatusModalDescription.js.map